import { render, staticRenderFns } from "./ExampleComponent1.vue?vue&type=template&id=3ad99bdc&scoped=true&"
import script from "./ExampleComponent1.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad99bdc",
  null
  
)

export default component.exports